import authInterceptor from "../AuthInterceptor";

export const UserProfileAPI = {
    postUpdateProfile: (body) =>
        authInterceptor.post(`accounts-api/edit-profile-api/`, body)
            .then((response) => response.data)
            .catch((error) => error.response),
    postChangePassword: (bodyData) =>
        authInterceptor.post(`accounts-api/reset-password-by-user-api/`, bodyData)
            .then((response) => response.data)
            .catch((error) => error.response)
}